module.exports = __webpack_public_path__ + "static/img/icon8-6.d6191068.png";